<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from "@/stores/modal.js";
import { useGarageStore } from "@/stores/garage.js";

export default {
  setup() {
    // I18n
    const { t } = useI18n();
    const translationPrefix = ref('modal.drivetrain_info');

    // Stores
    const modalStore = useModalStore();
    const garageStore = useGarageStore();

    // Variables
    const isLoading = ref(true);

    onMounted(async () => {});

    return {
      t,
      translationPrefix,
      modalStore,
      garageStore,
      isLoading,
    }
  },
};
</script>

<template>
  <div class="flex flex-col space-y-4 w-full px-8 py-4">
    <div class="w-full">
      <p class="font-semibold text-lg modal-header">{{ t(`${translationPrefix}.modal_body`) }}</p>
      <p class="text-md text-gray-600">{{ t(`${translationPrefix}.modal_body_text`) }}</p>
    </div>
      <div class="container mt-2">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-2 gap-y-2">
          <div class="flex flex-col px-0 sm:px-2 space-y-2">
            <div class="w-full">
              <label for="config" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.config_label`) }}</label>
              <input type="text" id="config" name="config" v-model="modalStore.newVehicle.specifications.engine_config" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.config_placeholder`)">
            </div>
            <div class="w-full">
              <label for="cylinders" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.cylinders_label`) }}</label>
              <input type="text" id="cylinders" name="cylinders" v-model="modalStore.newVehicle.specifications.cylinders" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.cylinders_placeholder`)">
            </div>
            <div class="w-full">
              <label for="displacement" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.displacement_label`) }}</label>
              <input type="text" id="displacement" name="displacement" v-model="modalStore.newVehicle.specifications.displacement" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.displacement_placeholder`)">
            </div>
            <div class="w-full">
              <label for="aspiration" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.aspiration_label`) }}</label>
              <input type="text" id="aspiration" name="aspiration" v-model="modalStore.newVehicle.specifications.aspiration" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.aspiration_placeholder`)">
            </div>
          </div>
          <div class="flex flex-col px-0 sm:px-2 space-y-2">
            <div class="w-full">
              <label for="fuel_type" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.fuel_type_label`) }}</label>
              <input type="text" id="fuel_type" name="fuel_type" v-model="modalStore.newVehicle.specifications.fuel_type" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.fuel_type_placeholder`)">
            </div>
            <div class="w-full">
              <label for="trans_type" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.trans_type_label`) }}</label>
              <input type="text" id="trans_type" name="trans_type" v-model="modalStore.newVehicle.specifications.trans_type" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.trans_type_placeholder`)">
            </div>
            <div class="w-full">
              <label for="trans_speed" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.trans_speed_label`) }}</label>
              <input type="text" id="trans_speed" name="trans_speed" v-model="modalStore.newVehicle.specifications.trans_speed" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.trans_speed_placeholder`)">
            </div>
            <div class="w-full">
              <label for="drivetrain" class="block text-gray-600 font-semibold">{{ t(`${translationPrefix}.drivetrain_label`) }}</label>
              <input type="text" id="drivetrain" name="drivetrain" v-model="modalStore.newVehicle.specifications.drivetrain" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t(`${translationPrefix}.drivetrain_placeholder`)">
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/components/modals/garage';
</style>
